import { Action } from '../../../redux/redux.types';
import {
  replicationsList,
  ReplicationsListState,
} from './replications-list.reducer';
import { replicationsUi, ReplicationsUiState } from './replications-ui.reducer';

export interface ReplicationsState {
  replicationsList: ReplicationsListState;
  replicationsUi: ReplicationsUiState;
}

export const replications = (
  state: Partial<ReplicationsState> = {},
  action: Action,
): ReplicationsState => {
  const uiState = replicationsUi(state.replicationsUi, action);

  return {
    replicationsList: replicationsList(state.replicationsList, action),
    replicationsUi: uiState,
  };
};
